import base from "../../base";
import userIsAdmin from "../Shared/functions/userIsAdmin";

export default async function verifyUser(uid, userToVerify) {
	if (!(await userIsAdmin(uid))) return;

	base.post(`users/${userToVerify}/verified/`, { data: true });
}
